import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import OrgAvatar from './OrgAvatar'
import P2 from '../typography/paragraphs/P2'
import Caption1 from '../typography/captions/Caption1'
import { getDisplayRole } from '../../utils/user'
import { setCurrentOrganization } from '../../actions/organization'
import { getOrgInitials } from '../../utils/organization'

const OrgWrapper = styled.li`
  border-top: 1px solid rgb(151, 151, 151, 0.21);
  margin: 0 5px;
  height: 75px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
`

export default class Organization extends React.Component {
  constructor() {
    super()
    this.onClickBound = this.onClick.bind(this)
  }

  render() {
    const { organization } = this.props
    const roles = this.getOrganizationRoles()
    return (
      <OrgWrapper onClick={this.onClickBound}>
        <OrgAvatar
          organization={organization}
          style={{ height: '38px', width: '38px' }}
          orgInitials={getOrgInitials(organization)}
        />
        <div style={{ paddingLeft: '15px' }}>
          <P2>{organization.name}</P2>
          <Caption1 className="role">{getDisplayRole(roles)}</Caption1>
        </div>
      </OrgWrapper>
    )
  }

  onClick() {
    const { dispatch, organization } = this.props
    dispatch(setCurrentOrganization(organization.id, organization.roles, true))
  }

  getOrganizationRoles() {
    const { organization, user } = this.props
    const org = user.organizations.find(function (org) {
      return org.id === organization.id
    })

    return org.roles
  }
}

Organization.propTypes = {
  dispatch: PropTypes.func,
  organization: PropTypes.object,
  user: PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/mini/Organization.js